// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xProductPartNumbersStyles from "@ces/App/SharedStyles/ProductPartNumbersStyles";
import { autocompleteProductsStyles } from "@ces/Overrides/Widgets/Header/AutocompleteProducts";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, ellipsis, mergeWithCss, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

autocompleteProductsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 0;
        .autocomplete-products-container {
            margin: 0;
            cursor: auto;
        }
    `,
};

autocompleteProductsStyles.headerText = {
    variant: "h6",
    css: css`
        margin: 0;
    `,
};

autocompleteProductsStyles.erpWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

autocompleteProductsStyles.imageGridItem = {
    width: 3,
    css: css`
        max-width: 98px;
        height: 98px;
        flex-basis: 98px;
        border-radius: 2px;
        overflow: hidden;
    `,
};

autocompleteProductsStyles.infoGridItem = {
    width: 9,
    css: css`
        flex-direction: column;
        max-width: calc(100% - 110px);
        flex-basis: calc(100% - 110px);
        gap: 8px;
        &&&& {
            margin-left: 12px;
        }
    `,
};

autocompleteProductsStyles.image = {
    css: css`
        width: 98px;
        height: 98px;
        img {
            aspect-ratio: 1/1;
            object-fit: contain;
        }
    `,
};

autocompleteProductsStyles.erpNumberText = {
    ...xProductPartNumbersStyles.label,
};

autocompleteProductsStyles.erpNumberValue = {
    ...mergeWithCss(xProductPartNumbersStyles.value, {
        css: css`
            b {
                color: ${color("common.black")};
            }
        `,
    }),
};

autocompleteProductsStyles.titleLink = {
    color: "text",
    typographyProps: {
        size: 12,
        lineHeight: "13px",
        css: css`
            width: 100%;
            margin: 0;
            ${ellipsis(2)}
            b {
                font-weight: ${fontConfig.weight.black};
            }
        `,
    },
};

autocompleteProductsStyles.productActions = {
    addToCartContainer: {
        css: css`
            &:empty {
                display: none;
            }
            margin-top: 11px;
            ${xScreen("lte", "xs")} {
                min-width: auto;
            }
        `,
    },
};

autocompleteProductsStyles.productsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
    `,
};

autocompleteProductsStyles.productDetailsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    `,
};
